import React from "react";

function DriverIcon() {
    return (
        <svg
            viewBox="0 0 9.196 12"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                transform="translate(-59.824)"
                d="M68.917,7.035l-.9-2.233A1.52,1.52,0,0,0,66.6,3.848h-.535a2.276,2.276,0,1,0-3.287,0h-.535a1.52,1.52,0,0,0-1.415.954l-.9,2.233a1.389,1.389,0,0,0,.393,1.585l1.24,1.046a2.923,2.923,0,0,0,5.726,0l1.24-1.046A1.388,1.388,0,0,0,68.917,7.035ZM62.849,2.276a1.573,1.573,0,1,1,1.573,1.573A1.574,1.574,0,0,1,62.849,2.276Zm-.492,7.616.322.053.168-.516h.538a1.1,1.1,0,0,0,.685.685v1.155A2.226,2.226,0,0,1,62.357,9.891Zm.568-2.452a2.215,2.215,0,0,1,2.993,0l-.522.149.37,1.137h-.309a1.094,1.094,0,0,0-2.073,0h-.309l.37-1.137Zm1.5,2.029a.392.392,0,1,1,.392-.392A.392.392,0,0,1,64.422,9.469Zm.352,1.8V10.113a1.1,1.1,0,0,0,.685-.685H66l.168.516.322-.053A2.226,2.226,0,0,1,64.773,11.268Zm3.3-3.186L66.84,9.121l-.195.032-.355-1.089.3-.085.394.011.019-.7-.278-.008a2.919,2.919,0,0,0-4.605,0l-.279.008.019.7.394-.011.3.085L62.2,9.153,62,9.121,60.772,8.083a.687.687,0,0,1-.194-.784l.9-2.233a.82.82,0,0,1,.763-.515H66.6a.82.82,0,0,1,.763.515l.9,2.233A.687.687,0,0,1,68.071,8.083Z"
            />
        </svg>
    );
}

export default DriverIcon;
